import { clsx } from 'clsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCirclePauseInverted,
  faCirclePlayInverted,
  faCircleStopInverted,
} from './playbackIcons';

export type PlaybackIconName = 'circle-play' | 'circle-pause' | 'circle-stop';

const PLAYBACK_ICONS = {
  'circle-play': faCirclePlayInverted,
  'circle-pause': faCirclePauseInverted,
  'circle-stop': faCircleStopInverted,
} as const;

type PlaybackIconProps = {
  icon: PlaybackIconName;
  className?: string;
};

export function PlaybackIcon({ icon, className }: PlaybackIconProps) {
  return (
    <FontAwesomeIcon
      icon={PLAYBACK_ICONS[icon]}
      className={clsx('shrink-0', className)}
      aria-hidden
    />
  );
}
